import './App.scss';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './componets/pages/home/home';

import UnGraduateTemplate from 'componets/templates/underGraduate/unGraduateTemplate';
import Menu from './componets/pages/menu/menu';
import Programs from './componets/pages/programs/programs';
import UnGraduate from './componets/pages/unGraduate/unGraduate';

import AboutUs from 'componets/pages/aboutUs/aboutUs';
import Calendar from 'componets/pages/calendar/calendar';
import Extension from 'componets/pages/extension/extension';
import ExtensionCourses from 'componets/pages/extensionCourses/extensionCourses';
import Graduates from 'componets/pages/graduates/graduates';
import Laboratories from 'componets/pages/laboratories/laboratories';
import Paperwork from 'componets/pages/paperwork/paperwork';
import Projects from 'componets/pages/projects/projects';
import Research from 'componets/pages/research/research';
import Seedbeds from 'componets/pages/seedbeds/seedbeds';
import { publicURL } from 'utilities/variables';
function App() {
  return (
    <div className="App">
      <BrowserRouter basename={publicURL} >
        <Routes>
          <Route path ={`/`} element = {
            <Home/>
          }>
          </Route>
          <Route path ={`/menu`} element = {
              <>
            
            <Menu/>
            </>
          }></Route>
          <Route path ={`/programas`} element = {
              <>
            <Programs/>
            </>
          }></Route>
          <Route path ={`/programa/:id/*`} element = {
              <>
            <UnGraduate/>
            </>
          }></Route>
          <Route path ={`/calendario`} element = {
            <Calendar/>
          }></Route>
          <Route path ={`/acercade`} element = {<AboutUs/> }></Route>
          <Route path ={`/acercade/*`} element = {<AboutUs/> }></Route>
          <Route path ={`/pregrado`} element = {
            <UnGraduateTemplate/>
          }></Route>
          <Route path ={`/programas`} element = {
            <Programs/>
          }></Route>
          <Route path ={`/investigacion`} element = {
            <Research/>
          }></Route>
          <Route path ={`/semilleros`} element = {
            <Seedbeds/>
          }></Route>
          <Route path ={`/laboratorios`} element = {
            <Laboratories/>
          }></Route>
          <Route path ={`/tramites/*`} element = {
            <Paperwork/>
          }></Route>
          <Route path ={`/tramites/`} element = {
            <Paperwork/>
          }></Route>
          <Route path ={`/extension`} element = {
            <Extension/>
          }></Route>
          <Route path ={`/proyectos`} element = {
            <Projects/>
          }></Route>
          <Route path ={`/cursosdeextension`} element = {
            <ExtensionCourses/>
          }></Route>
          <Route path ={`/diplomados`} element = {
            <Graduates/>
          }></Route>
        </Routes>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
